(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = () => {
    const nodes = document.querySelectorAll('[data-4173-reveal]');
    if (reduced || !('IntersectionObserver' in window)) { nodes.forEach((node) => node.classList.add('is-revealed')); return; }
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); observer.unobserve(entry.target); } }), { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach((node) => observer.observe(node));
  };
  const pointerLight = () => {
    if (reduced || !window.matchMedia('(min-width: 990px)').matches) return;
    document.querySelectorAll('[data-4173-light]').forEach((target) => {
      let x = 50, y = 50, targetX = 50, targetY = 50, frame;
      const render = () => { x += (targetX - x) * .08; y += (targetY - y) * .08; target.style.setProperty('--dcw-x', `${x}%`); target.style.setProperty('--dcw-y', `${y}%`); if (Math.abs(targetX - x) + Math.abs(targetY - y) > .1) frame = requestAnimationFrame(render); else frame = undefined; };
      target.addEventListener('pointerenter', () => target.classList.add('is-pointer-lit'));
      target.addEventListener('pointerleave', () => target.classList.remove('is-pointer-lit'));
      target.addEventListener('pointermove', (event) => { const rect = target.getBoundingClientRect(); targetX = ((event.clientX - rect.left) / rect.width) * 100; targetY = ((event.clientY - rect.top) / rect.height) * 100; if (!frame) frame = requestAnimationFrame(render); });
    });
  };
  const parallax = () => {
    if (reduced || !window.matchMedia('(min-width: 990px)').matches) return;
    const visual = document.querySelector('[data-4173-parallax]'); if (!visual) return;
    let queued = false;
    window.addEventListener('scroll', () => { if (queued) return; queued = true; requestAnimationFrame(() => { const hero = visual.closest('.theme-4173-hero'); const progress = Math.max(-1, Math.min(1, window.scrollY / Math.max(hero.offsetHeight, 1))); visual.style.transform = `translate3d(0, ${progress * 14}px, 0)`; queued = false; }); }, { passive: true });
  };
  const menu = () => {
    document.querySelectorAll('[data-4173-menu-toggle]').forEach((button) => {
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (!nav) return;
      button.addEventListener('click', () => { const open = nav.classList.toggle('is-open'); button.setAttribute('aria-expanded', String(open)); });
    });
  };
  document.addEventListener('DOMContentLoaded', () => { reveal(); pointerLight(); parallax(); menu(); });
})();
